import React from "react";
import Layout from "../../components/Layout";
import ScrollToTop from "../../components/ScrollToTop";
import SessionCheck from "../../components/SessionCheck";
import NavHeader from "../../components/NavHeader";
import IntMortgageApp from "../../views/MortgageView/int-mortgage-app";

const InternalMortgageAppPage = () => {
  return (
    <Layout>
      <ScrollToTop />
      <SessionCheck shouldRedirect />
      <NavHeader pageTitle="Mortgage" routeName="mortgage" />
      <IntMortgageApp />
    </Layout>
  ); 
};
 
export default InternalMortgageAppPage;
